module.exports = __webpack_public_path__ + "static/media/june 2021.18f71413.svg";